<template>
    <cmpRec v-bind:name="name"
                   v-bind:pkColumn="pkColumn"
                   v-bind:fields="fields"
                   v-bind:parent="parent"
                   v-bind:header="header"></cmpRec>
</template>

<script>
    import i18n from '@/i18n'
    import cmpRec from "@/components/common/cmpRec"

    export default {
        components: {
            cmpRec
        },
        computed: {
            fields() {
                return [
                    { "key": "DeviceId", "label": i18n.t('component.DeviceTables.DeviceId.label')},
                    { "key": "HardwareDeviceId", "label": i18n.t('component.DeviceTables.HardwareDeviceId.label')},
                    { "key": "UnitId", "label": i18n.t('component.DeviceTables.UnitId.label')},
                    
                ]
            },
            header() {
                return i18n.t('component.DeviceTables.recHeader')
            }
        },
        data() {

            return {
                name: "DeviceTables",
                pkColumn: "DeviceTableId",
                parent: {}
            };
        }
    }
</script>